import { useState } from "react";
import { useUserInfor } from "../../../../../../Context/User";
import {
    DesvincularTemplateModuloController,
    GetTemplatesDesvinculadosPorModulosController,
    GetTemplatesPorModulosController,
    VincularTemplateModuloController,
} from "../../../../../../Controllers/Geral/TemplatesModulo/TemplatesModuloControllers";
import { ACESSOS } from "../../../../../../Routes/Acessos";

import VinculadorSimples from "../../../../../Table/Vinculador";
interface TemplatesProps {
    idTipoCaso: number;
}

const ModuloFormatado: Record<number, { nome: string } | undefined> = {
    // Contatos
    [ACESSOS.ASSISTENCIA.ID_MODULO]: {
        nome: "Assitencia Técnica",
    } as const,
    [ACESSOS.ATENDIMENTO.ID_MODULO]: {
        nome: "Atendimento",
    } as const,
    [ACESSOS.COBRANCA.ID_MODULO]: {
        nome: "Cobrança",
    } as const,
    [ACESSOS.HELPDESK.ID_MODULO]: {
        nome: "Atendimento Whatsapp",
    } as const,
    [ACESSOS.REPASSE.ID_MODULO]: {
        nome: "Repasse",
    } as const,
    [ACESSOS.VENDAS.ID_MODULO]: {
        nome: "Vendas",
    } as const,
} as const;

export default function TemplatesPorModulo(props: TemplatesProps) {
    const { UserInfor } = useUserInfor();
    const [moduloSelecionado, setModuloSelecionado] = useState(
        UserInfor.MODULOS[0].ID_MODULO
    );

    function handleSelectChange(event: any) {
        setModuloSelecionado(event.target.value);
    }

    return (
        <>
            <select
                defaultValue={"Selecione um Modulo"}
                className="form-control"
                onChange={handleSelectChange}
            >
                {UserInfor.MODULOS.map((modulo, index) => (
                    <option
                        defaultValue={"Selecione um Modulo"}
                        key={index}
                        value={modulo.ID_MODULO}
                    >
                        {ModuloFormatado[modulo.ID_MODULO]?.nome ??
                            modulo.DS_MODULO}
                    </option>
                ))}
            </select>

            <VinculadorSimples
                id={moduloSelecionado ?? 1}
                listarVinculados={GetTemplatesPorModulosController}
                listarNaoVinculados={
                    GetTemplatesDesvinculadosPorModulosController
                }
                multiplo={{
                    desvincular: (templatesPorModulo) =>
                        DesvincularTemplateModuloController(
                            templatesPorModulo.map(
                                (templateModulo) =>
                                    templateModulo.ID_DOCUMENTO_TEMPLATE_MODULO ??
                                    0
                            )
                        ),
                    vincular: (idModulo, templatesPorModulo) =>
                        VincularTemplateModuloController(
                            idModulo,
                            templatesPorModulo.map(
                                (templateModulo) =>
                                    templateModulo.ID_DOCUMENTO_TEMPLATE
                            )
                        ),
                }}
                tabelaVinculados={{
                    text: "Templates Vinculados",
                    dataField: "DS_DOCUMENTO",
                    key: "ID_DOCUMENTO_TEMPLATE",
                }}
                tabelaDesvinculados={{
                    text: "Templates desvinculados",
                    dataField: "DS_DOCUMENTO",
                    key: "ID_DOCUMENTO_TEMPLATE",
                }}
            />
        </>
    );
}
